module.exports = __webpack_public_path__ + "static/aon-high-cost-cc5096ea576016eb6c4a7ddd702bc68e.png";